import RestClient from './RestClient';
import { Workflow } from '../../models';

class Workflows extends RestClient {
    constructor() {
        super({
            "model": Workflow,
            "entryPoint": "workflow",
            "resource": "workflow",
            "resources": "workflows",
            "id": "id"
        });
    }

    startWorkflow(workflow_id, tkt_instance_id) {
        return this.POST(`/workflow/start/id/${workflow_id}/tkt_instance/${tkt_instance_id}`)
            .then(response => response.json())
            .then(json => {
                if (json.workflow) {
                    json.workflow = new Workflow(json.workflow);
                    return json;
                }
                throw new Error(json.flash.error);
            });
    }

    doneBrick(workflow_id, tkt_instance_id, context) {
        context = context || {};

        return this.POST(`/workflow/done_brick/id/${workflow_id}/tkt_instance/${tkt_instance_id}`, { context })
            .then(response => response.json())
            .then(json => {
                if (json.workflow) {
                    json.workflow = new Workflow(json.workflow);
                    return json;
                }
                throw new Error(json.flash.error);
            });
    }

    getBrickResources(workflow_id, tkt_instance_id, brick_id) {
        const url = `/workflow/brick_resources/id/${workflow_id}` +
            `/tkt_instance/${tkt_instance_id}` +
            `/brick_id/${brick_id}`;

        return this.GET(url)
            .then(response => response.json())
            .then(json => {
                if (json.resources)
                    return json;
                throw new Error(json.flash.error);
            });
    }
}

const WorkflowsApi = new Workflows();

export default WorkflowsApi;
